@if (position().visible && !isPresentationActive()) {
  <div
    class="map-node-action-panel"
    [class.is-below-node]="position().verticalPlacement === 'below'"
    [style.left.px]="position().left"
    [style.top.px]="position().top"
    (click)="$event.stopPropagation()"
  >
    <div class="node-action-row">
      @for (action of visibleActionItems(); track action) {
        <button
          type="button"
          class="node-action-btn"
          [attr.data-testid]="'mindmap-node-action-' + action"
          [class.is-active]="activePopover() === action"
          [class.is-limit-disabled]="action === 'note' && mindMapNotesBlocked()"
          [attr.aria-disabled]="
            action === 'note' && mindMapNotesBlocked() ? 'true' : null
          "
          [attr.aria-label]="labelForAction(action)"
          [title]="labelForAction(action)"
          (click)="onActionClick(action, $event)"
        >
          <svg
            class="sa-icon sa-nofill"
            [class.node-ai-refine-icon]="action === 'refine'"
            aria-hidden="true"
            viewBox="0 0 24 24"
          >
            <use [attr.href]="iconForAction(action)"></use>
          </svg>
        </button>
      }
    </div>

    @if (activePopover() === "refine") {
      <div
        class="node-refine-popover"
        [class.is-positioned]="popoverPositioned()"
        [style.left.px]="popoverPosition().left"
        [style.top.px]="popoverPosition().top"
        [style.max-height.px]="popoverPosition().maxHeight"
        [style.max-width.px]="popoverPosition().maxWidth"
      >
        @for (item of refineActions; track item) {
          <button
            type="button"
            class="node-refine-item"
            [class.is-limit-disabled]="
              item === 'add-notes' && mindMapNotesBlocked()
            "
            [attr.aria-disabled]="
              item === 'add-notes' && mindMapNotesBlocked() ? 'true' : null
            "
            (click)="onRefineActionClick(item, $event)"
          >
            {{ labelForRefineAction(item) }}
          </button>
        }
      </div>
    }

    @if (activePopover() === "image") {
      <div
        class="node-refine-popover"
        [class.is-positioned]="popoverPositioned()"
        [style.left.px]="popoverPosition().left"
        [style.top.px]="popoverPosition().top"
        [style.max-height.px]="popoverPosition().maxHeight"
        [style.max-width.px]="popoverPosition().maxWidth"
      >
        @for (position of imagePositions; track position) {
          <button
            type="button"
            class="node-refine-item"
            [attr.data-testid]="'mindmap-node-image-position-' + position"
            (click)="setImagePosition(position, $event)"
          >
            {{ position }}
          </button>
        }
        <button
          type="button"
          class="node-refine-item text-danger"
          data-testid="mindmap-node-image-remove"
          (click)="removeNodeImage($event)"
        >
          <svg class="sa-icon sa-bold sa-nofill me-2" aria-hidden="true">
            <use href="/assets/icons/sprite.svg#trash-2"></use>
          </svg>
          Delete
        </button>
      </div>
    }

    @if (activePopover() === "style") {
      <div
        class="node-style-popover"
        [class.is-positioned]="popoverPositioned()"
        [style.left.px]="popoverPosition().left"
        [style.top.px]="popoverPosition().top"
        [style.max-height.px]="popoverPosition().maxHeight"
        [style.max-width.px]="popoverPosition().maxWidth"
      >
        <div class="node-style-tabs">
          <button
            type="button"
            class="node-style-tab"
            data-testid="mindmap-node-style-tab-shape"
            [class.is-active]="activeStyleTab() === 'shape'"
            (click)="setStyleTab('shape', $event)"
          >
            {{ translations().shape }}
          </button>
          <button
            type="button"
            class="node-style-tab"
            data-testid="mindmap-node-style-tab-border"
            [class.is-active]="activeStyleTab() === 'border'"
            (click)="setStyleTab('border', $event)"
          >
            {{ translations().border }}
          </button>
          <button
            type="button"
            class="node-style-tab"
            data-testid="mindmap-node-style-tab-line"
            [class.is-active]="activeStyleTab() === 'line'"
            (click)="setStyleTab('line', $event)"
          >
            Line
          </button>
        </div>

        @if (activeStyleTab() === "shape") {
          <section class="node-style-section">
            <div class="node-style-section-title">
              {{ translations().themeColors }}
            </div>
            <div class="node-color-grid">
              <button
                type="button"
                class="node-color-swatch is-theme"
                [class.is-selected]="isThemeBackgroundColor()"
                title="ColorTheme"
                aria-label="ColorTheme"
                (click)="setThemeBackgroundColor($event)"
              >
                <img
                  src="/assets/icons/appearance.svg"
                  alt=""
                  aria-hidden="true"
                />
              </button>
              <button
                type="button"
                class="node-color-swatch is-none"
                [class.is-selected]="isNoBackgroundColor()"
                title="Sem cor"
                aria-label="Sem cor"
                (click)="setNoBackgroundColor($event)"
              ></button>
              @for (color of themeColors(); track color) {
                <button
                  type="button"
                  class="node-color-swatch"
                  [class.is-selected]="isBackgroundColor(color)"
                  [style.background-color]="color"
                  (click)="setBackgroundColor(color, $event)"
                ></button>
              }
            </div>
          </section>

          <section class="node-style-section">
            <label class="node-custom-color">
              <span>{{ translations().customColor }}</span>
              <input
                type="color"
                data-testid="mindmap-node-background-custom"
                [value]="currentBackgroundColor()"
                (input)="setBackgroundColor($any($event.target).value, $event)"
              />
            </label>
          </section>

          <section class="node-style-section">
            <div class="node-style-section-title">
              {{ translations().shape }}
            </div>
            <div class="node-shape-options">
              <button
                type="button"
                class="node-shape-btn is-default"
                [class.is-selected]="isShape(null)"
                [title]="labelForShape(null)"
                [attr.aria-label]="labelForShape(null)"
                (click)="setShape(null, $event)"
              ></button>
              <button
                type="button"
                class="node-shape-btn is-line"
                [class.is-selected]="isLineShape()"
                title="Line shape"
                aria-label="Line shape"
                [disabled]="!canSetLineShape()"
                (click)="setLineShape($event)"
              ></button>
              @for (shape of shapeOptions; track shape.id) {
                <button
                  type="button"
                  class="node-shape-btn"
                  [attr.data-testid]="'mindmap-node-shape-' + shape.id"
                  [class.is-selected]="isShape(shape.id)"
                  [style.border-radius]="shape.radius"
                  [title]="labelForShape(shape.id)"
                  [attr.aria-label]="labelForShape(shape.id)"
                  (click)="setShape(shape.id, $event)"
                ></button>
              }
            </div>
          </section>
        } @else if (activeStyleTab() === "border") {
          <section class="node-style-section">
            <div class="node-style-section-title">
              {{ translations().themeColors }}
            </div>
            <div class="node-color-grid">
              <button
                type="button"
                class="node-color-swatch is-theme"
                [class.is-selected]="isThemeBorderColor()"
                title="ColorTheme"
                aria-label="ColorTheme"
                (click)="setThemeBorderColor($event)"
              >
                <img
                  src="/assets/icons/appearance.svg"
                  alt=""
                  aria-hidden="true"
                />
              </button>
              <button
                type="button"
                class="node-color-swatch is-none"
                [class.is-selected]="isNoBorderColor()"
                title="Sem borda"
                aria-label="Sem borda"
                (click)="setNoBorderColor($event)"
              ></button>
              @for (color of themeColors(); track color) {
                <button
                  type="button"
                  class="node-color-swatch"
                  [class.is-selected]="isBorderColor(color)"
                  [style.background-color]="color"
                  (click)="setBorderColor(color, $event)"
                ></button>
              }
            </div>
          </section>

          <section class="node-style-section">
            <label class="node-custom-color">
              <span>{{ translations().customColor }}</span>
              <input
                type="color"
                [value]="currentBorderColor()"
                (input)="setBorderColor($any($event.target).value, $event)"
              />
            </label>
          </section>

          <section class="node-style-section">
            <div class="node-border-visual-options">
              @for (width of borderWidthOptions; track width.id) {
                <button
                  type="button"
                  class="node-border-visual-btn"
                  [attr.data-testid]="'mindmap-node-border-width-' + width.id"
                  [class.is-selected]="isBorderWidth(width.value)"
                  [attr.aria-label]="labelForBorderWidth(width.id)"
                  [title]="labelForBorderWidth(width.id)"
                  (click)="setBorderWidth(width.value, $event)"
                >
                  <span
                    class="node-border-line-sample"
                    data-variant="width"
                    [attr.data-width]="width.value"
                    aria-hidden="true"
                  ></span>
                </button>
              }

              @for (style of borderStyleOptions; track style.id) {
                <button
                  type="button"
                  class="node-border-visual-btn"
                  [attr.data-testid]="'mindmap-node-border-style-' + style.id"
                  [class.is-selected]="isBorderStyle(style.value)"
                  [attr.aria-label]="labelForBorderStyle(style.id)"
                  [title]="labelForBorderStyle(style.id)"
                  (click)="setBorderStyle(style.value, $event)"
                >
                  <span
                    class="node-border-line-sample"
                    data-variant="style"
                    [attr.data-style]="style.value"
                    aria-hidden="true"
                  ></span>
                </button>
              }
            </div>
          </section>
        } @else {
          <section class="node-style-section">
            <div class="node-style-section-title">Line color</div>
            <div class="node-color-grid">
              <button
                type="button"
                class="node-color-swatch is-theme"
                [class.is-selected]="selectedLineColor() === null"
                title="ColorTheme"
                aria-label="ColorTheme"
                (click)="resetLineColorsToTheme($event)"
              >
                <img
                  src="/assets/icons/appearance.svg"
                  alt=""
                  aria-hidden="true"
                />
              </button>
              @for (color of themeColors(); track color) {
                <button
                  type="button"
                  class="node-color-swatch"
                  [class.is-selected]="isLineColor(color)"
                  [style.background-color]="color"
                  [attr.aria-label]="color"
                  [title]="color"
                  (click)="setLineColor(color, $event)"
                ></button>
              }
            </div>
          </section>

          <section class="node-style-section">
            <label class="node-custom-color">
              <span>Custom Colors</span>
              <input
                type="color"
                [value]="selectedLineColor() ?? themeColors()[0]"
                aria-label="Custom line color"
                (input)="setLineColor($any($event.target).value, $event)"
              />
            </label>
          </section>

          <section class="node-style-section">
            <div class="node-style-section-title">Thickness</div>
            <div class="node-line-visual-options">
              @for (width of lineWidthOptions; track width.id) {
                <button
                  type="button"
                  class="node-line-visual-btn"
                  [attr.data-testid]="'mindmap-node-line-width-' + width.id"
                  [class.is-selected]="selectedLineWidth() === width.id"
                  [attr.aria-label]="labelForBorderWidth(width.id)"
                  [title]="labelForBorderWidth(width.id)"
                  (click)="setLineWidth(width.id, $event)"
                >
                  <span
                    class="node-line-sample"
                    data-variant="width"
                    [attr.data-width]="width.value"
                    aria-hidden="true"
                  ></span>
                </button>
              }
            </div>
          </section>

          <section class="node-style-section">
            <div class="node-style-section-title">Line style</div>
            <div class="node-line-visual-options">
              @for (style of lineStyleOptions; track style.id) {
                <button
                  type="button"
                  class="node-line-visual-btn"
                  [attr.data-testid]="'mindmap-node-line-style-' + style.id"
                  [class.is-selected]="selectedLineStyle() === style.id"
                  [attr.aria-label]="labelForBorderStyle(style.id)"
                  [title]="labelForBorderStyle(style.id)"
                  (click)="setLineStyle(style.id, $event)"
                >
                  <span
                    class="node-line-sample"
                    data-variant="style"
                    [attr.data-style]="style.value"
                    aria-hidden="true"
                  ></span>
                </button>
              }
            </div>
          </section>

          <section class="node-style-section">
            <div class="node-style-section-title">Line type</div>
            <div class="node-line-type-options">
              @for (type of lineTypeOptions; track type.id) {
                <button
                  type="button"
                  class="node-line-type-btn"
                  [attr.data-testid]="'mindmap-node-line-type-' + type.id"
                  [class.is-selected]="selectedLineType() === type.id"
                  [attr.aria-pressed]="selectedLineType() === type.id"
                  [attr.title]="type.label"
                  (click)="setLineType(type.id, $event)"
                >
                  <span
                    class="node-line-type-preview"
                    [attr.data-type]="type.id"
                    aria-hidden="true"
                  ></span>
                  <span>{{ type.label }}</span>
                </button>
              }
            </div>
          </section>
        }
      </div>
    }

    @if (activePopover() === "text") {
      <div
        class="node-style-popover"
        [class.is-positioned]="popoverPositioned()"
        [style.left.px]="popoverPosition().left"
        [style.top.px]="popoverPosition().top"
        [style.max-height.px]="popoverPosition().maxHeight"
        [style.max-width.px]="popoverPosition().maxWidth"
      >
        <section class="node-style-section">
          <div class="node-style-section-title">
            {{ translations().themeColors }}
          </div>
          <div class="node-color-grid">
            @for (color of textColors; track color) {
              <button
                type="button"
                class="node-color-swatch"
                [class.is-selected]="isTextColor(color)"
                [style.background-color]="color"
                (click)="setTextColor(color, $event)"
              ></button>
            }
          </div>
        </section>

        <section class="node-style-section">
          <label class="node-custom-color">
            <span>{{ translations().customColor }}</span>
            <input
              type="color"
              [value]="currentTextColor()"
              (input)="setTextColor($any($event.target).value, $event)"
            />
          </label>
        </section>

        <section class="node-style-section">
          <div class="node-style-section-title">
            {{ translations().font }}
          </div>
          <div class="node-font-options">
            @for (option of fontOptions; track option.id) {
              <button
                type="button"
                class="node-font-btn"
                [attr.data-testid]="'mindmap-node-font-' + option.id"
                [class.is-active]="isFontFamily(option.value)"
                [style.font-family]="option.previewFontFamily"
                [attr.title]="labelForFontOption(option)"
                [attr.aria-label]="labelForFontOption(option)"
                (click)="setFontFamily(option.value, $event)"
              >
                Abc
              </button>
            }
          </div>
        </section>

        <section class="node-style-section">
          <div class="node-style-section-title">
            {{ translations().format }}
          </div>
          <div class="node-format-options">
            <div class="node-format-group" aria-label="Format toggles">
              <button
                type="button"
                class="node-format-btn"
                data-testid="mindmap-node-format-bold"
                [class.is-active]="isBold()"
                (click)="toggleBold($event)"
              >
                <svg
                  class="sa-icon sa-nofill"
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                >
                  <use [attr.href]="iconForFormat('bold')"></use>
                </svg>
              </button>
              <button
                type="button"
                class="node-format-btn"
                [class.is-active]="isItalic()"
                (click)="toggleItalic($event)"
              >
                <svg
                  class="sa-icon sa-nofill"
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                >
                  <use [attr.href]="iconForFormat('italic')"></use>
                </svg>
              </button>
            </div>

            <span class="node-format-separator" aria-hidden="true"></span>

            <div class="node-format-group" aria-label="Text size options">
              @for (option of fontSizeOptions; track option.id) {
                <button
                  type="button"
                  class="node-size-btn"
                  [attr.data-testid]="'mindmap-node-font-size-' + option.id"
                  [class.is-active]="isFontSize(option.id)"
                  [attr.title]="labelForFontSize(option.id)"
                  [attr.aria-label]="labelForFontSize(option.id)"
                  [attr.data-size]="option.id"
                  (click)="setFontSize(option.id, $event)"
                >
                  <span class="node-size-preview" aria-hidden="true">A</span>
                </button>
              }
            </div>
          </div>
        </section>
      </div>
    }
  </div>
}
